import React from "react";
import {LayoutAuthWithForm} from "../../../layouts";
import {AuthInput, AuthPwdInput} from "../../../helpers/InputsHelpers";
import {Box} from "@material-ui/core";
import trim from "mn-utils/trim";
import {object, string} from "yup";
import {Link, replaceLocation} from "../../../../router";
import {
  LINK_SIGN_IN
} from "../../../../constants/links";
import {apiAuthPasswordRecovery, decorateReconnect} from "../../../../api/_auth";

export default (props) => {
  const params = props.params || {};

  const data = {token: params.token || ''};

  const schema = object({
    token: string().required(),
    password: string()
      .isValidNewPwd()
      .isValidPwdLength()
      .withoutCyrillicSymbols()
      .required(),
  });

  const sendRecoveryToken = decorateReconnect(apiAuthPasswordRecovery);

  const onSubmit = (data) => (
    sendRecoveryToken(data)
  );
  const onResult = () => {
    replaceLocation({
      path: LINK_SIGN_IN,
    })
  };

  const resultModalData = ['Your password has been changed!', 'Please try to login again.'];

  return (
    <LayoutAuthWithForm
      title="Reset password"
      description="Set a new password"
      formProps={{
        schema,
        data,
        onSubmit,
        onResult,
        resultModalData
      }}
      content={(formCtx) => (
        <>
          <AuthInput
            label="Recovery token"
            name="token"
            formCtx={formCtx}
            onChangeHandlers={[trim]}
          />
          <Box mt="3rem">
            <AuthPwdInput
              name="password"
              formCtx={formCtx}
              onChangeHandlers={[trim]}
            />
          </Box>
        </>
      )}
      beforeFooter={(
        <Link
          href={LINK_SIGN_IN}
          className="c5B47FF olN tdU dn f12 fw3 o70:h"
        >I have a password</Link>
      )}
      submitBtnText="Set password"
    />
  )
}
